import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport, faFileExport, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { LabelText } from '../../../components/Language';
import Aux from '../../../hoc/Auxiliary';
import HeaderTitle from '../../../hoc/HeaderTitle';
import './index.css';

export default function RevenueHeader(props) {
  
  const helpTooltip = (
    <Tooltip id="helpButton">
      <LabelText tid="help" />
    </Tooltip>
  )
  
  const showInstructions = () => {
    props.showInstructionshandler(true);
  }

  const exportTooltip = (
    <Tooltip id="exportButton">
      <LabelText tid="export" />
    </Tooltip>
  );

  const importTooltip = (
    <Tooltip id="importButton">
      <LabelText tid="import" />
    </Tooltip>
  );

  return (
    <Aux>     
      <HeaderTitle className = "Revenue-header-code-col col">
        <span className="Title-align">
          <LabelText tid="revenue" />
        </span>
        <span className="Code-align">
          {props.BusinessPartnerCode}
        </span>
      </HeaderTitle>
      <HeaderTitle className="Revenue-header-date-col">
        <div className="export-import-container">          
          <OverlayTrigger placement="bottom" overlay={exportTooltip}>
            <div role="button" title="Export to excel button" 
                 tabIndex="0" disabled={!props.isExportToExcelEnable} onClick={()=>props.handlerOnExportToExcelClick()}
                 onKeyDown={(e) => { if (e.key === "Enter") props.handlerOnExportToExcelClick()}}>
                  <FontAwesomeIcon className={props.isExportToExcelEnable ? "fa-export-icon" : "fa-export-icon disable-icon" } icon= {faFileImport} />
            </div>                 
          </OverlayTrigger>
          <div className="empty-div"/>
          <OverlayTrigger placement="top" overlay={importTooltip}>
            <div role="button" title="Import from excel button" className={!props.isRevenueAvailableToImport ? "disable-icon" : ""}
                 tabIndex="0" disabled={!props.isRevenueAvailableToImport} onClick={()=>props.handlerOnImportFromExcelClick()}
                 onKeyDown={(e) => { if (e.key === "Enter") props.handlerOnImportFromExcelClick()}} >
                    <FontAwesomeIcon className={"fa-import-icon"} icon= {faFileExport} />
           </div>
          </OverlayTrigger>           
          <div className="empty-div"/>
          <OverlayTrigger placement="bottom" overlay={helpTooltip}>
            <div role="button" title="Help button" onClick={showInstructions} tabIndex="0"
            onKeyDown={(e) => { if (e.key === "Enter") props.showInstructionshandler(true)}}  >
            <FontAwesomeIcon className="fa-help-icon" icon= {faInfoCircle} /> 
            </div>
          </OverlayTrigger>

        </div>
      </HeaderTitle>
    </Aux>
  );
}


